import Leaderboards from './Leaderboards'
import ThreadsCategory from './ThreadsCategory'
import Thread from './Thread'
import Comment from './Comment'

export default {
  Leaderboards,
  ThreadsCategory,
  Thread,
  Comment,
}
